import dateFormat from "dateformat";
import moment from "moment";

export const formatDate = (value, withTime = true, isJSONObject = false) => {
  if (value == null || value === "") return "";
  let raw = isJSONObject ? safeJsonParse(value) : value;

  // Numeric epoch (seconds or milliseconds)
  if (typeof raw === "number" || (typeof raw === "string" && /^\d+$/.test(raw.trim()))) {
    const num = Number(raw);
    if (Number.isFinite(num)) {
      const ms = num > 1e11 ? num : num * 1000; // treat big numbers as ms
      const date = new Date(ms);
      if (!isNaN(date.getTime())) {
        return dateFormat(date, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
      }
    }
  }

  // Format unix epoch seconds (strict)
  if (moment(raw, "X", true).isValid()) {
    const date = new Date(Number(raw) * 1000);
    return dateFormat(date, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
  }

  // Format strings like "18-Oct-2025"
  const momentObj = moment(raw, ["DD-MMM-YYYY", "D-MMM-YYYY", "DD-MMM-YY"], true);
  if (momentObj.isValid()) {
    const date = momentObj.toDate();
    // return dateFormat(date, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
    return dateFormat(date, "dS mmm yyyy"); // omit time for date-only inputs
  }

  const str = String(raw);
  const iso = str.endsWith("Z") ? str : str + "Z";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return dateFormat(d, withTime ? "dS mmm yyyy, h:MM TT" : "dS mmm yyyy");
};

const safeJsonParse = (s) => {
  try { return JSON.parse(s); } catch { return s; }
};

export const convertDateParam = (date) => {
  return moment(date).format("yyyy-MM-DDTHH:mm:ss:SSS+00:00");
};

export const convertTillDateParam = (date) => {
  return moment(date).format("yyyy-MM-DDT23:59:59:999+00:00");
};

export const isValidDate = (dateString) => {
  if (!dateString) {
    return true;
  }
  // First check for the pattern
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) return false;

  // Parse the date parts to integers
  var parts = dateString.split("/");
  var day = parseInt(parts[1], 10);
  var month = parseInt(parts[0], 10);
  var year = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) return false;

  var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0))
    monthLength[1] = 29;

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
};
